import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OmissionTrackingRoutingModule } from '@ic-pages/omission-inspection/tracking/omission-tracking.routing';

@NgModule({
  declarations: [],
  imports: [CommonModule, OmissionTrackingRoutingModule]
})
export class OmissionTrackingModule {}
